export const section = {
  title: 'Where Artfinder got featured',
  images: [
    {
      id: 'bbc',
      src: `${process.env.NEXT_PUBLIC_IMAGE_STATIC_URL}/img/logos/360w/bbc.png`,
      alt: 'BBC logo',
      width: 276,
      height: 80,
    },
    {
      id: 'fastCompany',
      src: `${process.env.NEXT_PUBLIC_IMAGE_STATIC_URL}/img/logos/360w/fast_company.png`,
      alt: 'FastCompany logo',
      width: 360,
      height: 52,
    },
    {
      id: 'houseAndGarden',
      src: `${process.env.NEXT_PUBLIC_IMAGE_STATIC_URL}/img/logos/360w/house-garden.png`,
      alt: 'House & Garden logo',
      width: 212,
      height: 80,
    },
    {
      id: 'bloomberg',
      src: `${process.env.NEXT_PUBLIC_IMAGE_STATIC_URL}/img/logos/360w/bloomberg.png`,
      alt: 'Bloomberg logo',
      width: 360,
      height: 67,
    },
    {
      id: 'sundayTimes',
      src: `${process.env.NEXT_PUBLIC_IMAGE_STATIC_URL}/img/logos/360w/sunday_times.png`,
      alt: 'The Sunday Times logo',
      width: 360,
      height: 80,
    },
    {
      id: 'cnn',
      src: `${process.env.NEXT_PUBLIC_IMAGE_STATIC_URL}/img/logos/360w/cnn.png`,
      alt: 'CNN logo',
      width: 172,
      height: 80,
    },
  ],
};
